import styles from "./Input.module.css";
import InputHeader from "./InputHeader";
import InputCard from "../containers/InputCard";

const TextArea = ({
  label,
  onChange,
  identifier,
  placeholder,
  value,
  required = false,
}) => {
  return (
    <InputCard>
      <InputHeader text={label} required={required} />
      <div className={styles.textAreaDiv}>
        <textarea
          className={styles.textArea}
          placeholder={placeholder}
          name={identifier}
          id={identifier}
          onChange={onChange}
          value={value}
        ></textarea>
      </div>
    </InputCard>
  );
};

export default TextArea;
